import React from 'react';
import { Link, Button, Flex, Box } from '@chakra-ui/react';
import { CarbonIconType, Download20 } from '@carbon/icons-react';
import Heading from '#coreComponents/Heading';
import Card from '#coreComponents/Card';
import { EventType, useTracking } from '#core/Tracking';

type ServiceCardProps = {
  name: string;
  downloadUrl: string;
  icon: CarbonIconType;
};

const ServiceCard: React.FC<ServiceCardProps> = ({
  name,
  downloadUrl,
  icon,
}) => {
  const { trackEvent } = useTracking();

  const onClick = () => {
    const fileExt = downloadUrl.split('.').pop();
    trackEvent({
      type: EventType.DOWNLOAD,
      payload: { id: downloadUrl, fileType: fileExt || 'marketing' },
    });
  };

  return (
    <Card
      as={Flex}
      flexDirection="column"
      justifyContent="space-between"
      borderLeft="8px solid black"
      p={3}
      borderRadius={0}
    >
      <Box>
        <Flex mb={3}>
          <Box as={icon} color="black" mr={2} width={7} />

          <Heading as="h2" fontSize="xl" display="inline">
            {name}
          </Heading>
        </Flex>

        <Link ml={7} href={downloadUrl} isExternal>
          <Button
            onClick={onClick}
            variant="outline"
            borderRadius="md"
            rightIcon={<Download20 />}
            px={6}
          >
            Download
          </Button>
        </Link>
      </Box>
    </Card>
  );
};

export default ServiceCard;
